import React from 'react';
import Header from '../../sections/Header';
import Banner from '../../sections/Banner';
import Footer from '../../sections/Footer';
import SectionHeader from '../../composites/SectionHeader';
import FeatureCard from '../../composites/FeatureCard';
import Breadcrumbs from '../../sections/Breadcrumbs';

const InitiativeOne: React.FC = () => {
  const roles = [
    {
      title: 'Master',
      description: 'I can build these tools',
      image: '/logos/Master.svg',
      link: { href: '/maker', label: 'Learn More', variant: 'secondary' as const, size: 'sm' as const },
    },
    {
      title: 'Maker',
      description: 'I can co-create with these tools',
      image: '/logos/Maker.svg',
      link: { href: '/maker', label: 'Learn More', variant: 'secondary' as const, size: 'sm' as const },
    },
    {
      title: 'Manager',
      description: 'I can scale my output with these tools',
      image: '/logos/Manager.svg',
      link: { href: '/manager', label: 'Learn More', variant: 'secondary' as const, size: 'sm' as const },
    },
  ];

  return (
    <>
      <Header />
      <Banner
        breadcrumbs={<Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Initiatives', href: '/initiatives' }, { label: 'AI Literacy Uplift & Alignment' }]} />}
        title="AI Literacy Uplift & Alignment"
        subtitle="Building AI fluency and confidence across the organization through structured learning pathways and hands-on experience."
        colorVariant="gradient"
        imageVariant="withImage"
        paddingVariant="default"
        showCTAs={true}
        showDefaultGraphic={true}
      />

      <div className="bg-white w-full">
        <div className="max-w-7xl mx-auto px-4 py-12">
          <SectionHeader
            heading="Explore Your AI Journey"
            description="We know people at (i.e.,) will get value from AI in different ways—some by building, some by co-creating, others by simply getting more done. These three pathways reflect those different starting points."
          />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
            {roles.map((role, idx) => (
              <div key={role.title} className="bg-white rounded-xl shadow-sm border border-gray-100 flex flex-col items-left p-8 text-left h-full">
                <div className="flex items-center gap-4 mb-4">
                  <img src={role.image} alt={role.title} className="w-12 h-12 object-contain" />
                  <h3 className="text-xl font-semibold text-gray-900">{role.title}</h3>
                </div>
                <p className="text-gray-600 mb-6 flex-grow">{role.description}</p>
                <a href={role.link.href} className="text-teal-600 hover:text-teal-700 font-medium">
                  {role.link.label} →
                </a>
              </div>
            ))}
          </div>

          <div className="mt-12 p-6 bg-gray-50 rounded-lg">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Coming Soon</h3>
            <p className="text-gray-600">
              We're continuously building out resources, guides, and opportunities for each AI Lab role. Check back regularly for updates!
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default InitiativeOne; 